import { DigitalDataOrigin, ProductWithCategoryType } from '../utils/digital-data-types'
import { CampaignType } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { ProductDigitalData } from '../utils/product-digital-data'
import type { Props } from './product-card-gallery'
import { Maybe, ProductTypeProps } from '.'
import { WindowBreakpoints } from '@dustin-web/microsite-config'
type PromotedProduct = {
  imageUrl: string
  campaignTitle: string
}

export const handeOnClickProduct = (
  digitalDataOrigin: Props['digitalDataOrigin'],
  product?: Maybe<ProductTypeProps>,
  index?: number
) => {
  if (index === undefined || !product) {
    return
  }

  ProductDigitalData.pushSelectItem(
    {
      ...product,
      productListIndex: index,
      label: getProductLabels(product as ProductTypeProps),
    } as ProductWithCategoryType,
    digitalDataOrigin
  )
}

export const getProductLabels = (
  product: ProductTypeProps & Partial<PromotedProduct>,
  isCampaignProduct?: boolean
) => {
  const price = product.price
  const badgeArray: string[] = []

  if (price?.isCampaign) {
    switch (price.campaignType) {
      case CampaignType.NewLowerPrice:
        badgeArray.push('NewLowerPrice')
        break
      case CampaignType.LimitedBatch:
        badgeArray.push('LimitedBatch')
        break
      case CampaignType.Campaign:
        badgeArray.push(`${price.campaignPercentage?.toString() ?? 'unknown'}_percent_discount`)
        break
      default:
        badgeArray.push('unknown_campaign') // just because
    }
  } else if (price?.isBid) {
    badgeArray.push('Product_IsBidPrice')
  } else if (product.isNewProduct) {
    badgeArray.push('Badge_New')
  } else if (isCampaignProduct) {
    badgeArray.push(`${product.campaignTitle?.toUpperCase()}`)
  } else if (price?.isBestSeller) {
    badgeArray.push('Badge_TopSeller')
  } else if (price?.isRecommendedProduct) {
    badgeArray.push('Badge_Recommended')
  }

  if (!badgeArray.length) return null
  return badgeArray
}

export function pushViewItemList(
  digitalIndex?: number,
  product?: ProductWithCategoryType | ProductTypeProps,
  digitalDataOrigin?: DigitalDataOrigin,
  isCampaignProduct?: boolean
) {
  if (product && digitalDataOrigin && digitalIndex !== undefined) {
    ProductDigitalData.pushViewItemList(
      [
        {
          ...product,
          productListIndex: digitalIndex,
          label: getProductLabels(product as ProductTypeProps, isCampaignProduct),
        },
      ] as ProductWithCategoryType[],
      digitalDataOrigin
    )
  }
}

export function getImageWidthHeight(breakpoints: WindowBreakpoints) {
  const defaultImageWidth = breakpoints.min.MD ? 180 : 190
  const defaultImageHeight = breakpoints.min.MD ? 130 : 140
  const mobileWidth = breakpoints.min.MD ? 160 : 190
  const mobileHeight = breakpoints.min.MD ? 160 : 140

  return { defaultImageWidth, defaultImageHeight, mobileWidth, mobileHeight }
}

export const getShowBadge = (product: Props['product']) =>
  product.availability?.isAvailableForSale &&
  (product.isNewProduct ||
    product.price?.isBestSeller ||
    product.price?.isBid ||
    product.price?.isCampaign ||
    product.price?.isRecommendedProduct)
